/*
 * 指向物联网平台的通用请求接口，与物联网平台通讯的api都基于此
 */
import axios from 'axios'
import Vue from 'vue'
import router from '@/router'
import localToken from './local-token.js'

const service = axios.create({
  baseURL: process.env.IOT_BASE_URL,
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 // request timeout
})

service.interceptors.request.use(
  config => {
    // 在头部带上authorization
    config.headers['authorization'] = localToken.read() || ''
    return config
  },
  error => {
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    // 如果响应头携带了authorization（通常是登录成功或刷新登录时携带），就存进localStorage，后续请求都带这个头
    const auth = response.headers['authorization']
    if (auth) {
      localToken.write(auth)
    }
    // 取出真正的数据（剥去axios额外包的一层）
    const res = response.data

    // 可以检查数据中自定义的响应码
    if (res.code !== 20000) {
      Vue.prototype.$message.error(`系统提示：${res.message}`)
      if (res.code === 50014) {
        // 登录身份失效了
        router.push('/Login')
      }
      return Promise.reject(new Error(res.message || 'Error'))
    }

    // 返回真正的数据部分
    return res
  },
  error => {
    // 出错的处理
    console.log('err' + error)
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/api/.request-cloud.js